import { newE2EPage } from "@stencil/core/testing";

describe("ux-steps-item", () => {
    it("should render a component", async () => {
        const page = await newE2EPage();
        await page.setContent(template());
        await page.waitForChanges();
        const el = await page.find("ux-steps-item");
        expect(el).toHaveClass("hydrated");
    });

    it("should match to snapshot", async () => {
        const page = await newE2EPage();
        await page.setContent(template());
        await page.waitForChanges();
        const el = await page.find("ux-steps-item");
        expect(el).toMatchSnapshot();
    });
});

function template() {
    return `
        <ux-steps-item 
            number="1" 
            done="true"
            current="false"
        >
            Some text
        </ux-steps-item>
    `;
}
